/**
 * @generated SignedSource<<89c248424a65d583254baa781b745fb5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SignalPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
import { FragmentRefs } from "relay-runtime";
export type SignalListItem_signal$data = {
  readonly breadcrumbs: ReadonlyArray<string>;
  readonly descriptionImages: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"AHImageStackComponent_Images">;
  }>;
  readonly id: string;
  readonly orgIconUri: string | null;
  readonly priority: SignalPriority;
  readonly title: string;
  readonly " $fragmentType": "SignalListItem_signal";
};
export type SignalListItem_signal$key = {
  readonly " $data"?: SignalListItem_signal$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignalListItem_signal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignalListItem_signal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priority",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "breadcrumbs",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgIconUri",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AHImageStackComponent_Images"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Signal",
  "abstractKey": null
};

(node as any).hash = "0d2119b6336ac40c93826482f6b6f0c2";

export default node;
